import SeoHead from '@atoms/SeoHead';
import type { ColumnLayoutType } from '@molecules/ColumnLayout/ColumnLayout.types';
import Layout from '@molecules/Layout';
import type { LayoutProps } from '@molecules/Layout/Layout.types';
import { getClient } from '@sanity/lib/getClient';
import ContactPageView from '@views/ContactPageView';
import type { GetStaticProps } from 'next';
import type { ReactElement } from 'react';

interface ContactPageProps {
  columnLayout: ColumnLayoutType;
  layoutData: Omit<LayoutProps, 'children'>;
}

const ContactPage = ({
  layoutData,
  columnLayout,
}: ContactPageProps): ReactElement => (
  <>
    <SeoHead
      metaDescription="Jeżeli masz pytania dotyczące tego bloga, propozycję współpracy lub po prostu chcesz się przywitać, napisz do mnie."
      title="✉️ Kontakt"
    />
    <Layout {...layoutData}>
      <ContactPageView columnLayout={columnLayout} />
    </Layout>
  </>
);

export const getStaticProps: GetStaticProps<ContactPageProps> = async () => {
  const client = getClient();

  const { getBasicData, getAllCategories } = await import('@lib/sanity');
  const { mapLayout } = await import('@mappers/layout');
  const { mapColumnLayout } = await import('@mappers/columnLayout');

  const tags = await getAllCategories(client);
  const layoutData = mapLayout(tags);
  const basicData = await getBasicData(client);
  const columnLayout = mapColumnLayout(basicData);

  return {
    props: {
      layoutData,
      columnLayout,
    },
  };
};

export default ContactPage;
